import range from 'lodash/range';

export const getMarkText = tLength => {
  const markValue = range(tLength)
    .map(() => '*')
    .join('');
  return markValue;
};
